<!--
 * @Date: 2020-07-22 09:57:52
 * @LastEditTime: 2020-11-27 10:10:58
 * @Description: 代理主机
--> 

<template>
  <div class="container">
    <div class="top-search">
      <div class="search">
        <div class="content">
          <el-form :model="searchParams" inline>
            <el-form-item label="主机名称" prop="roleName">
              <el-input
                v-model="searchParams.name"
                placeholder="请输入主机名称"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              />
            </el-form-item>
            <el-form-item label="用户名" prop="roleName">
              <el-input
                v-model="searchParams.addr"
                placeholder="请输入用户名"
                clearable
                style="width: 240px"
                @keyup.enter.native="search"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="search-btns">
          <div class="left-line" />
          <div class="right-btns mg">
            <el-button
              type="primary"
              icon="el-icon-plus"
              round
              class="search-btn"
              @click="rowAdd"
              >新增主机</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-search"
              round
              class="search-btn"
              @click="search"
              >搜索</el-button
            >
            <el-button
              icon="el-icon-refresh"
              round
              class="reset-btn"
              @click="reset"
              >重置</el-button
            >
          </div>
          <div class="left-line" />
        </div>
      </div>
    </div>

    <div class="table-container">
      <el-table
        :data="list.slice((pagination.page -1)*pagination.limit, pagination.page*pagination.limit)"
        v-loading="loading"
        empty-text="暂无数据"
        style="width: 100%"
        height="600"
        :row-style="{ background: '#FCFDFF' }"
        :header-cell-style="{ background: '#2d3a5b', color: '#ffffff' }"
      >
        <el-table-column
          align="center"
          label="主机IP"
          prop="host"
        ></el-table-column>
        <el-table-column
          align="center"
          label="端口"
          prop="port"
        ></el-table-column>
        <el-table-column
          align="center"
          label="用户名"
          prop="username"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          label="加密方式"
          prop="method"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          label="代理类型"
          prop="type"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          label="名称"
          prop="name"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column align="center" label="是否启用">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enabled"
              @change="changeSwitch($event, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="rowUpdate(row)"
              >修改</el-button
            >
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              @click="rowDelete(row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      :total="pagination.total"
      :page.sync="pagination.page"
      :limit.sync="pagination.limit"
    />

    <!-- 修改 新增 dialog -->
    <el-dialog :visible.sync="dialogForm" :title="dialogFormTitle">
      <el-form
        :model="formTemp"
        status-icon
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="代理主机IP" prop="host">
              <el-input
                type="text"
                placeholder="请输入代理主机IP"
                v-model="formTemp.host"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理端口" prop="port">
              <el-input
                type="number"
                placeholder="请输入代理端口"
                v-model="formTemp.port"
                autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="用户名" prop="username">
              <el-input
                type="text"
                placeholder="请输入用户名"
                v-model="formTemp.username"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="password">
              <el-input
                type="password"
                placeholder="请输入密码"
                v-model="formTemp.password"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="加密方式" prop="method">
              <el-input
                type="text"
                placeholder="请输入加密方式"
                v-model="formTemp.method"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="代理类型" prop="type">
              <el-select v-model="formTemp.type" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="名称" prop="name">
              <el-input
                type="text"
                placeholder="请输入名称"
                v-model="formTemp.name"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否启用" prop="enabled">
              <el-switch v-model="formTemp.enabled"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="reset-btn" @click="dialogForm = false"
          >取消</el-button
        >
        <el-button type="primary" class="search-btn" @click="submitForm()"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import {
  proxyList,
  proxyCreate,
  proxyDelete,
  proxyUpdate,
} from "@/api/proxy.js";

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      loading: false,
      dialogDetail: false,
      dialogForm: false,
      dialogFormTitle: "",
      searchParams: {
        name: "",
        tel: "",
        addr: "",
      },
      // 代理类型
      options: [
        {
          value: "socks5",
          label: "socks5",
        },
        {
          value: "http",
          label: "http",
        },
        {
          value: "https",
          label: "https",
        },
      ],
      pagination: {
        limit: 30,
        page: 1,
        total: 0,
      },
      list: [],
      curRowId: 0,
      formTemp: {
        host: "",
        port: "",
        username: "",
        password: "",
        method: "",
        type: "",
        name: "",
        enabled: false,
      },
      // 表单提交验证
      rules: {
        host: [
          { required: true, message: "请输入代理主机IP", trigger: "blur" },
        ],
        port: [
          { required: true, message: "请输入代理端口", trigger: "change" },
        ],
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        type: [
          { required: true, message: "请选择代理类型", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    };
  },

  created() {
    this.getList();
  },

  methods: {
    getList() {
      this.loading = true;

      proxyList().then((res) => {
        this.loading = false;
        this.list = res;
        this.pagination.total = res.length;
      }).catch(() => {
        this.loading = false
      })
    },

    changeSwitch(e, row) {
      let _copy = Object.assign({}, row);
      _copy.enabled = e;

      proxyUpdate(_copy).then(() => {
        if (e) {
          this.notice("启用成功！");
        } else {
          this.notice("禁用成功！");
        }
      });
    },

    search() {},
    reset() {},

    rowAdd() {
      this.resetValue("新增主机", "", "", "", "", "", "", "", false, 0);
    },

    rowUpdate(row) {
      this.resetValue(
        "修改主机",
        row.host,
        row.port,
        row.username,
        row.password,
        row.method,
        row.type,
        row.name,
        row.enabled,
        row.id
      );
    },

    resetValue(
      title,
      host,
      port,
      username,
      password,
      method,
      type,
      name,
      enabled,
      id
    ) {
      this.dialogForm = true;
      this.dialogFormTitle = title;
      this.formTemp.host = host;
      this.formTemp.port = port;
      this.formTemp.username = username;
      this.formTemp.password = password;
      this.formTemp.method = method;
      this.formTemp.type = type;
      this.formTemp.name = name;
      this.formTemp.enabled = enabled;
      this.curRowId = id;
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },

    rowDelete(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          proxyDelete({ id: row.id }).then(() => {
            this.notice("删除成功");
          });
        })
        .catch(() => {});
    },

    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (this.curRowId === 0) {
            //新增
            proxyCreate(this.formTemp).then(() => {
              this.dialogForm = false;
              this.notice("新增成功！");
            });
          } else {
            //修改
            let _copy = Object.assign({}, this.formTemp);
            _copy.id = this.curRowId;

            proxyUpdate(_copy).then(() => {
              this.dialogForm = false;
              this.notice("修改成功！");
            });
          }
        } else {
          return false;
        }
      });
    },

    notice(message) {
      this.$notify({
        title: "成功",
        message,
        type: "success",
      });
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin flex($ali, $jus) {
  display: flex;
  align-items: $ali;
  justify-content: $jus;
}

.container {
  margin: 20px;
}

.top-search {
  display: flex;
  padding: 20px;
  width: 100%;
  // height: 100px;
  background: #ffffff;
  border: 1px solid #f0f3f7;
}
.table-container {
  min-height: 400px;
  margin-top: 20px;
  width: 100%;
  // border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 #eff2f7;
}
.search {
  // width: 1160px;
  // height: 160px;
  width: 100%;
  background: #ffffff;
  border-radius: 10px;
  // margin: 0 auto;
  //   overflow: hidden;
  .content {
    @include flex(center, space-between);
    border-radius: 4px;
    // height: 76px;
    width: 100%;
    margin: 0 auto;
  }
}
.search-btn {
  background-color: #2d3a5b;
  border: #2d3a5b;
}
.reset-btn {
  background-color: #ffffff;
  color: #2d3a5b;
  border: 1px solid #2d3a5b;
}
</style>
